import React from "react";
import { Link } from "react-router-dom";

import LogoImg from "../../../assets/images/logo.png";
import { loginPath } from "../../../teacherStore";

import styles from "./MultiFactorAuthenticationForm.module.scss";

export interface MultiFactorAuthenticationFormProps {
  calling: boolean;
  onSubmit: (mfa_code: string) => void;
}

const validates: { [key: string]: (value: any) => string } = {};

validates["mfa_code"] = val => {
  return val.mfa_code.trim() ? "" : "この項目は入力が必須です。";
};

export const MultiFactorAuthenticationForm = (
  props: MultiFactorAuthenticationFormProps,
) => {
  const [state, setState] = React.useState({
    mfa_code: "",
    errorMessages: {} as { [key: string]: string },
  });

  const onSubmit = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      const errorMessages = {} as { [key: string]: string };
      Object.keys(validates).forEach(key => {
        const ret = validates[key](state);
        if (ret) {
          errorMessages[key] = ret;
        }
      });
      if (Object.keys(errorMessages).length > 0) {
        setState(s => ({ ...s, errorMessages }));
        return;
      }
      props.onSubmit(state.mfa_code.trim());
    },
    [state, props],
  );

  const onChange = React.useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      const val =
        e.currentTarget.type === "checkbox"
          ? e.currentTarget.checked
          : e.currentTarget.value;
      const key = e.currentTarget.name;
      const args = { [key]: val };
      const ret = validates[key] ? validates[key](args) : "";
      setState(prevState => ({
        ...prevState,
        [key]: val,
        errorMessages: { ...prevState.errorMessages, [key]: ret },
      }));
    },
    [],
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <img src={LogoImg} alt="" />
      </div>
      <main className={styles.main}>
        <h3>LOGIN</h3>
        <div>
          <form onSubmit={onSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="mfa_code">認証コード</label>
              <div className={styles.wrapInput}>
                <input
                  type="text"
                  name="mfa_code"
                  className={
                    state.errorMessages["mfa_code"] && styles.errorForm
                  }
                  id="mfa_code"
                  value={state.mfa_code}
                  onChange={onChange}
                />
                <div className={styles.error}>
                  {state.errorMessages["mfa_code"]}
                </div>
              </div>
            </div>
            <button
              className={styles.btnSubmit}
              onClick={onSubmit}
              disabled={
                props.calling ||
                Object.keys(state.errorMessages).filter(
                  k => state.errorMessages[k],
                ).length > 0
              }
            >
              送信
            </button>
          </form>
          <div className="d-flex justify-content-center">
            <Link to={loginPath} className={styles.backToLogin}>
              ログイン画面に戻る
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MultiFactorAuthenticationForm;
